import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTheme, fonts } from "@/theme";
import { useAuth } from "@/context/AuthContext";
import { useToast } from "@/lib/toast";
import { AuthShell, Field, AuthButton } from "@/pages/auth/AuthShell";

export default function Register() {
  const { colors } = useTheme();
  const { register } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name || !email || !password) {
      toast.show("Fill in all the fields to get set up.");
      return;
    }
    if (password.length < 8) {
      toast.show("Password needs to be at least 8 characters.");
      return;
    }
    setLoading(true);
    try {
      await register(name.trim(), email.trim().toLowerCase(), password);
      navigate("/", { replace: true });
    } catch (err) {
      toast.show(err.message);
    } finally {
      setLoading(false);
    }
  };

  const linkStyle = { color: colors.brandSecondary, fontFamily: fonts.text, fontWeight: 700, textDecoration: "none" };

  return (
    <AuthShell>
      <h2 style={{ color: colors.onSurface, fontSize: 22, fontFamily: fonts.display, fontWeight: 700, margin: "0 0 4px" }}>Join the Weirdos ✨</h2>
      <p style={{ color: colors.muted, fontSize: 14, fontFamily: fonts.text, margin: "0 0 20px" }}>
        Use the email RitzyRa invited you with to set up your account.
      </p>
      <form onSubmit={submit}>
        <Field label="Your name" testId="register-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Luna" />
        <Field label="Email" testId="register-email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
        <Field label="Password" testId="register-password" type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 8 characters" />
        <AuthButton loading={loading} data-testid="register-submit">Create account</AuthButton>
      </form>
      <p style={{ color: colors.muted, fontSize: 14, textAlign: "center", marginTop: 20, fontFamily: fonts.text }}>
        Already have an account?{" "}
        <Link to="/login" data-testid="go-login" style={linkStyle}>Sign in</Link>
      </p>
    </AuthShell>
  );
}
